import React from "react";
import { Link } from "react-router-dom";

function InfoItem(props) {
  return (
    <>
      <li className="cards__item_info">
        <Link className="cards__item__link_info" to={props.path}>
          <figure
            className="cards__item__pic-wrap_info"
            data-category={props.label}
          >
            <img src={props.src} alt="" className="cards__item_info__img" />
          </figure>
          <div className="cards__item__info_yes">
            <h5 className="cards__item__text_info">{props.text}</h5>
          </div>
        </Link>
      </li>
    </>
  );
}

export default InfoItem;
